import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { ResizeObserver } from '@juggle/resize-observer';
import { useRefDep } from './ref-dep';
var INITIAL_STATE = {
  width: 0,
  height: 0
};
var OBSERVER_OPTS = {
  box: 'border-box'
};

/**
 * Monitors and returns the element size.
 * @param {React.RefObject<HTMLELement|null>} ref
 */
export function useElementSize(ref) {
  var _React$useState = React.useState(INITIAL_STATE),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    size = _React$useState2[0],
    setSize = _React$useState2[1];
  React.useEffect(function () {
    if (!ref.current) {
      setSize(INITIAL_STATE);
      return;
    }
    var element = ref.current;
    var observer = new ResizeObserver(function (entries) {
      entries.forEach(function (e) {
        var _e$borderBoxSize = _slicedToArray(e.borderBoxSize, 1),
          _e$borderBoxSize$ = _e$borderBoxSize[0],
          width = _e$borderBoxSize$.inlineSize,
          height = _e$borderBoxSize$.blockSize;
        setSize({
          width: width,
          height: height
        });
      });
    });
    observer.observe(element, OBSERVER_OPTS);
    return function () {
      observer.unobserve(element);
      observer.disconnect();
    };
  }, [useRefDep(ref)]);
  return size;
}
//# sourceMappingURL=element-size.js.map
